import { render, staticRenderFns } from "./integral_order.vue?vue&type=template&id=1a837156&scoped=true&"
import script from "./integral_order.vue?vue&type=script&lang=js&"
export * from "./integral_order.vue?vue&type=script&lang=js&"
import style0 from "./integral_order.vue?vue&type=style&index=0&id=1a837156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a837156",
  null
  
)

export default component.exports